import { useEffect, useRef, Fragment, useState } from "react";
import { moveTo } from "../../utils/dom";
import { wait } from "../../utils/promises";
import classes from './CorrectionSummary.module.scss'
import Page from "../Page";
import Correction from "../Correction";

const MARGIN_SCROLL = 27 * 3 // 3 text lines of margin

export default function CorrectionSummary(props) {
    const { corrections, onFinish, animated } = props;
    const correctionsRef = useRef({})
    const [isAnimating, setIsAnimating] = useState(false)
    const noteRef = useRef(null)

    useEffect(() => {
        if (!animated) return;

        const handleShowCorrections = async () => {
            setIsAnimating(true)

            const elements = Object.values(correctionsRef.current)

            for (let i = 0; i < elements.length; i++) {
                const element = elements[i]

                // calculate the position of the element
                const boxOffset = noteRef.current?.offsetTop ?? 0;
                const elementOffset = element.getOffsetTop()

                // move the element to the top
                const position = Math.max(0, elementOffset - boxOffset - MARGIN_SCROLL)
                await moveTo(noteRef.current, position)

                // show the element
                await element.show()

                // move the element to top again, to make sure it's visible after showing
                await moveTo(noteRef.current, position)

                // wait for 2.5s before moving to the next element
                await wait(2500)
            }
            // wait for a second before calling onFinish
            await wait(1000)

            setIsAnimating(false)
            onFinish()
        }

        handleShowCorrections()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animated])

    return (
        <Page className={isAnimating ? classes.disabled : ""} ref={noteRef}>
            {corrections.map((sentences, sentenceIndex) => (
                <Fragment key={`sentence-${sentenceIndex}`}>
                    {sentenceIndex > 0 && <br />}

                    {sentences.map((sentence, index) => (
                        <Fragment key={index}>
                            {sentence.isCorrect ? (
                                sentence.expected
                            ) : (
                                <Correction
                                    ref={el => correctionsRef.current[`${sentenceIndex}-${index}`] = el}
                                    {...sentence}
                                    animated={animated}
                                />
                            )}
                        </Fragment>
                    ))}
                </Fragment>
            ))}
        </Page>
    )
}